export default __webpack_public_path__ + "static/media/tags.411fd298.svg";